"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Image = createSVGIcon(
  <>
    <rect
      x=".625"
      y="3.482"
      width="18.75"
      height="13.988"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="m1.2 16.952 4.788-8.24A1 1 0 0 1 7.643 8.6l2.18 2.809a1 1 0 0 0 1.441.145l1.206-1.036a1 1 0 0 1 1.441.145l4.889 6.288"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M15.5 7.143c0 .49-.424.928-1 .928s-1-.438-1-.928.424-.929 1-.929 1 .439 1 .929Z"
      stroke="currentColor"
    />
  </>,
  "ImageIcon",
  { viewBox: "0 0 20 20", fill: "none", className: legacyIconCls() }
);
